import React from "react";
import { Row, Col, Button } from 'react-bootstrap';
import styles from "./WelcomeJKOA.module.css";
import './WelcomeJKOA.module.css';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

export default function WelcomeJKOA() {
    return (
        <React.Fragment>
            <div className={`home-section-container`}>
                <div>
                    <Row>
                        <Col lg="6" md="6" xs="12">
                            <img className="img-fluid" alt="welcome-img" src="https://sajkoaonline.blob.core.windows.net/jkoa/other/welcometoJKOA.png"></img>
                        </Col>

                        <Col lg="6" md="6" xs="12" className={`${styles.selectedDetailSection}`}>
                            <Row>
                                <Col lg="12" md="12" xs="12" className={`${styles.selectedBrandHeading}`}>
                                    <span>Welcome to JKOA</span>
                                </Col>
                                <Col lg="12" md="12" xs="12" className={`${styles.mainHeading}`}>
                                    <span>PRODUCTS
                                        FOR EVERY
                                        JOB</span>
                                </Col>
                                <Col lg="12" md="12" xs="12">
                                    <p>We offer a wide range of office automation solutions, comprising a product portfolio of world-renowned brands. Continually listening to the needs of customers and focusing on our social, environmental and economic responsibility we have achieved significance and success in the local market. While we service the corporate sector clientele directly, consumer markets are covered by a growing base of dealers and resellers located island wide.
                                    </p>
                                </Col>
                                <Col lg="12" md="12" xs="12">
                                    <div>
                                        <Button onClick={() => window.location.href = "/aboutus"}
                                            className={`jkoa-blue-btn`}>
                                            <div style={{ padding: "0.3rem 1rem" }}> Explore</div>
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )
}